import React, { useState } from 'react';

export interface VendorFilters {
  name?: string;
  code?: string;
  department?: string;
  status?: string;
  month?: string;
  year?: string;
  state?: string;
  vendor_category?: string;
  nature_of_service?: string;
}

interface VendorFilterPanelProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (filters: VendorFilters) => void;
  departments?: string[];
}

export const VendorFilterPanel: React.FC<VendorFilterPanelProps> = ({ isOpen, onClose, onApply, departments = [] }) => {
  const [filters, setFilters] = useState<VendorFilters>({});

  if (!isOpen) return null;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleClear = () => {
    setFilters({});
    onApply({});
    onClose();
  };

  const handleApply = () => {
    const cleanFilters: Record<string, string> = {};
    Object.entries(filters).forEach(([k, v]) => {
      if (v) cleanFilters[k] = v;
    });
    onApply(cleanFilters);
  };

  return (
    <div className="filter-panel">
      <div className="filter-group">
        <label>Vendor Name</label>
        <input name="name" type="text" placeholder="Search by name" value={filters.name || ''} onChange={handleChange} />
      </div>
      <div className="filter-group">
        <label>Vendor Code</label>
        <input name="code" type="text" placeholder="e.g. V001" value={filters.code || ''} onChange={handleChange} />
      </div>
      <div className="filter-group">
        <label>Department</label>
        <select name="department" value={filters.department || ''} onChange={handleChange}>
          <option value="">All Departments</option>
          {departments.map(d => <option key={d} value={d}>{d}</option>)}
        </select>
      </div>
      <div className="filter-group">
        <label>Status</label>
        <select name="status" value={filters.status || ''} onChange={handleChange}>
          <option value="">All Statuses</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>
      <div className="filter-group">
        <label>Location (State)</label>
        <select name="state" value={filters.state || ''} onChange={handleChange}>
          <option value="">All States</option>
          {[
            "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", 
            "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", 
            "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", 
            "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", 
            "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", 
            "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Jammu and Kashmir"
          ].map(st => <option key={st} value={st}>{st}</option>)}
        </select>
      </div>
      <div className="filter-group">
        <label>Vendor Category</label>
        <select name="vendor_category" value={filters.vendor_category || ''} onChange={handleChange}>
          <option value="">All Categories</option>
          <option value="regular">Regular</option>
          <option value="one_time">One-time</option>
          <option value="retainer">Retainer</option>
        </select>
      </div>
      <div className="filter-group">
        <label>Nature of Service</label>
        <input name="nature_of_service" type="text" placeholder="e.g. Consulting" value={filters.nature_of_service || ''} onChange={handleChange} />
      </div>
      <div className="filter-actions">
        <button className="secondary-btn" onClick={handleClear}>Clear</button>
        <button className="primary-btn" onClick={handleApply}>Apply Filters</button>
      </div>
    </div>
  );
};
